module.exports = __webpack_public_path__ + "img/CouponRush.f6f37a36.svg";